export const randInt = (max: number) => Math.floor(Math.random() * max);

export const newCacheBuster = () => randInt(1_000_000);
